import { render } from "./AppAdminLayout.vue?vue&type=template&id=76b9d910"
import script from "./AppAdminLayout.vue?vue&type=script&lang=js"
export * from "./AppAdminLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__